import iconTime from "../../../../assets/icon_time.svg";
import iconOff from "../../../../assets/icon_off.svg";
import iconAdd from "../../../../assets/icon_add.svg";
import iconOpen from "../../../../assets/icon_open.svg";
import iconClose from "../../../../assets/icon_close.svg";
import iconStore from "../../../../assets/icon_store.svg";
import useSelectBrand from "../../../../hooks/styles/useSelectBrand";

//영업중, 휴업중 등 뱃지 (디자인 미정)
const StatusBadge = ({ isOpen, bgColor }) => {
  const statusMap = {
    OP: {
      text: "영업중",
      icon: iconOpen,
      color: "text-black",
      bg: `bg-${bgColor}`,
    },
    PR: {
      text: "영업준비중",
      icon: iconClose,
      color: "text-white",
      bg: "bg-zinc-700",
    },
    CL: {
      text: "영업종료",
      icon: iconClose,
      color: "text-white",
      bg: "bg-zinc-700",
    },
    OF: {
      text: "휴점일",
      icon: iconClose,
      color: "text-white",
      bg: "bg-zinc-700",
    },
  };

  const { text, icon, color, bg } = statusMap[isOpen] || {
    text: "",
    icon: null,
    color: "text-white",
    bg: "bg-zinc-700",
  };

  return (
    <span
      className={`inline-flex items-center justify-center py-2 px-3 text-sm rounded-[50px] ${color} ${bg} gap-1.5`}
    >
      {icon && <img src={icon} alt="" />}
      {text}
    </span>
  );
};

//점포 상세 정보 (영업정보, 휴점일, 주소)
const InfoItem = ({ icon, title, content }) => {
  const contentClass = title === "휴점일" ? "text-red-400" : "text-gray-600";

  return (
    <li className="flex items-start">
      <div className="flex shrink-0 items-center w-[90px] gap-2 font-semibold">
        <span>
          <img src={icon} alt={title} />
        </span>
        <p>{title}</p>
      </div>
      <p className={`font-medium break-words ${contentClass}`}>{content}</p>
    </li>
  );
};

//점포 상세 정보 외 다른 정보들(현금 없는 매장)
const ExtraInfoItem = ({ icon, title = {}, content }) => {
  return (
    <li className="flex gap-1 leading-6">
      <div className="flex items-center w-auto gap-2 font-semibold ">
        <span className="shrink-0">
          <img src={icon} alt="" />
        </span>
        <p>{title}</p>
      </div>
      <p className="flex items-center text-sm font-medium text-gray-600">
        {content}
      </p>
    </li>
  );
};

// 주소를 포맷팅하는 함수
const formatAddress = (address1, address2) => {
  if (!address1) return null;
  return (
    <>
      {address1}
      {address2 && (
        <>
          <br />
          {address2}
        </>
      )}
    </>
  );
};

//점포 정보
const StoreInfo = ({
  branchName,
  storeClose,
  workingTime,
  location,
  isOpen,
  cashless,
  fc,
}) => {
  const { color } = useSelectBrand();
  return (
    <div className="mb-5">
      <div className="mb-4 text-3xl font-semibold">
        <h2 className="inline mr-2.5 align-middle">{branchName}</h2>
        <StatusBadge isOpen={isOpen} bgColor={color} />
      </div>
      <ul>
        <InfoItem
          icon={iconOff}
          title="휴점일"
          content={storeClose?.join(", ")}
        />

        <InfoItem icon={iconTime} title="영업시간" content={workingTime} />
        <InfoItem
          icon={iconAdd}
          title="주소"
          content={`${location?.address1} ${location?.address2}`}
        />
        {cashless === "Y" &&
          (fc === "Y" ? (
            <ExtraInfoItem
              icon={iconStore}
              title="현금없는매장"
              content="(상품권 및 이마티콘 사용 불가점)"
            />
          ) : (
            <ExtraInfoItem icon={iconStore} title="현금없는매장" />
          ))}
      </ul>
    </div>
  );
};

export default StoreInfo;
